import { render, staticRenderFns } from "./CourseOverviewCard.vue?vue&type=template&id=8e35754c&scoped=true&"
import script from "./CourseOverviewCard.vue?vue&type=script&lang=js&"
export * from "./CourseOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseOverviewCard.vue?vue&type=style&index=0&id=8e35754c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e35754c",
  null
  
)

export default component.exports